import "./ShinyText.scss";

const ShinyText = ({
  disabled = false,
  speed = 5,
  className = "",
  children,
  ...props
}) => {
  const animationDuration = `${speed}s`;

  return (
    <button
      className={`shiny-text ${disabled ? "disabled" : ""} ${className}`}
      style={{ animationDuration }}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default ShinyText;
